import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, Table, Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Footer from '../page-layout/footer/Footer';
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import "./Certificate.css";
import { data } from '../data/data';
import { RankWinners } from '../../utils/axios/ChallengeWinnerAPI';

const WinnerView = () => {
    // const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    // const [loading, setLoading] = useState(true);

    const BackBtn = () => { navigate('/businesschallenges'); }
    const [winnersdetail,setwinnerdetail] = useState([])
    const getRankwinners = async()=>{
        var winnerResponse = await RankWinners(); 
        setwinnerdetail(winnerResponse.data);
    }

    useEffect(() => {
        getRankwinners();
    }, [])

    return (

        <div className='page'>
        <div className='page-wrapper'>
            <div>
                <Navbar expand="lg" className="bg-body-tertiary">
                    <Container fluid>
                        <Navbar.Brand>
                            <div className='light-logo'>
                                <span className="navbar-brand">
                                    <img src={require("../../images/grok pvt ltd logo.png")} className="img-fluid navbar_logo" width={90} height={80} alt="patient-card" />
                                </span>
                            </div>
                            <div className='dark-logo'>
                                <span className="navbar-brand">
                                    <img src={require("../../images/grok pvt ltd logo_dark.png")} className="img-fluid navbar_logo" width={90} height={80} alt="patient-card" />
                                </span>
                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav className="ms-auto my-2 my-lg-0 demo_nav" style={{ maxHeight: '200px', maxWidth: '200px' }} navbarScroll >

                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
            <Container fluid>
                <div>
                    <div><span className='d-flex justify-content-center my-2 tableheader' lg={4} >Industry Use Case Winners</span></div>

                    <div className='py-2 p-4'>
                        <div className='card mb-3 mb-lg-5 '>
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md md-mb-0'>
                                        <h4 className='text-bold ms-1 mt-1'>Past Winners</h4>
                                    </Col>
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="backBtn_style" onClick={() => BackBtn()} >
                                            <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                            &nbsp;&nbsp;Back
                                        </button>
                                    </Col>
                                </Row>
                            </div>

                            <div className='m-4' style={{ maxHeight: '700px', overflowY: 'auto' }}>
                                <Row>
                                        {winnersdetail && winnersdetail.map((item,index)=>
                                    <Col lg={6} xl={6} sm={12} className="mb-3 mb-lg-5" key={index}>
                                        <Card className="winnerslist_card d-flex my-2">
                                            <Card.Body className='winners_body'>
                                                <div className="d-flex justify-content-between winnerhead_clr p-4">
                                                    <div className="d-flex">
                                                        <Card.Title className="winnerslist_head"></Card.Title>
                                                    </div>
                                                </div>
                                                <div className='winners_cardarea'>
                                                    <Card.Text className='winners_bg_img'>
                                                        <img src={require("../../images/grok pvt ltd logo.png")} className="img-fluid winner-img" width={180} height={180} alt="winner-logo" />

                                                        <div className="dropdown-item-text d-flex justify-content-between">
                                                            <div className="d-flex align-items-center">
                                                                <div className="winners_content flex-grow-1 ms-3 mt-4 mb-2">
                                                                    <h5>Congratulations to <b className="personcard_text"> {item.student.name}</b></h5>
                                                                    <p className="card-text text-body persontextpara">Winner of the industry use case challenge <br /> <b className="personcard_text">{item.challenge.name}</b> organized by <br /> <span className='personcard_text'>{item.challenge.companyName}</span></p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <img src={require("../../images/winner-medal-bg.png")} className="img-fluid mt-3 mx-3" width={80} height={80} alt="winner-logo" />
                                                            </div>
                                                        </div>
                                                    </Card.Text>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>)}
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Footer />
        </div>
    </div>
    )
}

export default WinnerView; 